import { OrganizationFeature } from '@gitbook/api-client';
import { isPricingFeatureAvailable } from '@gitbook/app-pricing';

import { useNavigationState } from '../../navigation';
import { useCurrentOrganization } from '../../state';

/**
 * Check the master AI setting and GitBook Agent entitlement for the current organization.
 */
export function useAgentEnabled(): boolean {
    const organization = useCurrentOrganization();
    return isPricingFeatureAvailable(organization, { featureKey: OrganizationFeature.AiLens });
}

/**
 * Whether the agent's entry points inside the editor should be offered.
 *
 * Only while the user is actually editing: these surfaces act on the content in front of them, and
 * one of them takes over the space key on an empty block, which has no business happening on a page
 * being read.
 */
export function useAgentInEditorEnabled(): boolean {
    const enabled = useAgentEnabled();
    // Subscribed to, not read out of the navigation functions: those do not change when the user
    // navigates, so a caller reading the state through them keeps whatever answer it had when it
    // last rendered — and this decides whether the space key opens the agent.
    const { screen } = useNavigationState();
    const isEditingSpace = screen.type === 'space' && screen.mode === 'edit';

    return isEditingSpace && enabled;
}
